// src/components/CustomSnackbar.js
import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Define a dark theme for Snackbar
const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const CustomSnackbar = ({ open, message, severity, onClose }) => {
  return (
    <ThemeProvider theme={darkTheme}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        autoHideDuration={2500}
        onClose={onClose}
      >
        <Alert
          onClose={onClose}
          severity={severity}
          variant="filled"
          sx={{ width: "auto", marginTop: "2rem" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
};

export default CustomSnackbar;
